import './App.css';
import { Inicio } from './Layouts/Inicio';
import { Provider, useSelector } from 'react-redux';
import { store } from './Store/Store';
import { Principal } from './Layouts/Principal';
import { CtrlLoader } from './Controles/CtrlLoader';
import { CtrlPopup } from './Controles/CtrlPopup';

const AppRender = () => {
  const inicio = useSelector(state => state.inicio)
  const { Login } = inicio;
  return (Login ? <Principal /> : <Inicio />)
}

function App() {

  return (
    <Provider store={store} >
      <CtrlPopup />
      <CtrlLoader />
      <AppRender />
    </Provider >
  );
}

export default App;
